import type { GetChatThreadById200CurrentUserStatus } from './getChatThreadById200CurrentUserStatus';
import type { GetChatThreadById200ParticipantsItem } from './getChatThreadById200ParticipantsItem';

export type GetChatThreadById200 = {
  chatRoomId: number;
  createdAt: string;
  currentUserStatus?: GetChatThreadById200CurrentUserStatus;
  isGroupThread: boolean;
  /** @nullable */
  lastMessage?: string | null;
  /** @nullable */
  lastMessageTime?: string | null;
  participants: GetChatThreadById200ParticipantsItem[];
  /** @nullable */
  unreadMessageCount?: number | null;
};
